import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH]: isLoading,
  [actionTypes.FETCH_SUCCESS]: isEnding,
  [actionTypes.FETCH_FAILURE]: isEnding,
});
